import React from 'react'
import { useTranslation } from 'react-i18next'
import {Result} from 'antd'
import {observer} from 'mobx-react'
import {useSearchParams} from 'react-router-dom'

import {withTitle} from '@/router/utils'
import {Button, Card} from '@/components'
import {useInjection} from 'dna-react-ioc'
import {TResetPasswordFailureStore} from './TResetPasswordFailureStore'
import {TRY_RESET_PASSWORD_AGAIN} from '@/constants/playwright-ids'

export const ResetPasswordFailureStoreSymbol = Symbol('ResetPasswordFailureStore')

const ResetPasswordFailure = observer(() => {
    const { t } = useTranslation()
    const [queryParams] = useSearchParams()
    const m = queryParams.get('m') || ''
    const store = useInjection<TResetPasswordFailureStore>(ResetPasswordFailureStoreSymbol)

    return <>
        <Card>
            <Result
                status={'error'}
                title={t('ResetPasswordFailure.somethingWentWrong')}
                subTitle={m ? m : t('ResetPasswordFailure.unexpectedError')}
                extra={(
                    <Button
                        type={'primary'}
                        key={'console'}
                        onClick={store.onTryAgainClick}
                        data-test-id={TRY_RESET_PASSWORD_AGAIN}
                    >
                        {t('ResetPasswordFailure.tryAgain')}
                    </Button>
                )}
            />
        </Card>
    </>
})

export default withTitle(ResetPasswordFailure)
